// ChannelPageAddSms.jsx
import React, { useState } from "react";
import ChannelAddForm from "../../../../components/ChannelAddForm/ChannelAddForm";

import { addSmsChannel } from "../../../../../../services/api/channels/add/sms";
import { ApiError } from "../../../../../../shared/utils/errors/ApiError";

import StepChannelName from "./steps/StepChannelName";
import StepSmsExplanation from "./steps/StepSmsExplanation";
import StepResult from "./steps/StepResult";

export default function CreateIntegrationAlcancePage() {
  const [currentStep, setCurrentStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [channelName, setChannelName] = useState("");
  const [nameError, setNameError] = useState("");

  const resetForm = () => {
    setSuccess(false);
    setLoading(false);
    setCurrentStep(1);
    setChannelName("");
    setNameError("");
  };

  const validateName = () => {
    if (!channelName.trim()) {
      setNameError("Digite um nome para o canal.");
      return;
    }

    setNameError("");
    setCurrentStep(2);
  };

  const handleAdd = async () => {
    try {
      setLoading(true);
      await addSmsChannel({ name: channelName });
      setSuccess(true);
      setCurrentStep(3);
    } catch (err) {
      setSuccess(false);
      setCurrentStep(3);

    } finally {
      setLoading(false);
    }
  };

  const steps = [
    {
      title: "Vamos começar?",
      description: (
        <span>
          Primeiro, escolha um nome interno para identificar este canal de SMS
          dentro da plataforma.
        </span>
      ),
      content: (
        <StepChannelName
          channelName={channelName}
          nameError={nameError}
          onChange={setChannelName}
        />
      ),
    },
    {
      title: "Vamos solicitar seu canal SMS?",
      description: <StepSmsExplanation />,
    },
    {
      title: success
        ? "SMS adicionado com sucesso!"
        : "Ops! Algo deu errado",
      description: <StepResult success={success} />,
    },
  ];

  return (
    <ChannelAddForm
      steps={steps}
      success={success}
      loading={loading}
      currentStep={currentStep}
      setCurrentStep={setCurrentStep}
      onSubmit={[validateName, handleAdd]}
      disableBack={loading}
      onRetry={resetForm}
    />
  );
}
